import React, { useState } from 'react';
import './ContributionUpdate.css'
import axiosInstance from '../axiosConfig';

const ContributionUpdate = ({ onClose }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [comments, setComments] = useState('');
    const [missingClubName, setMissingClubName] = useState('');
    const [missingClubState, setMissingClubState] = useState('');
    const [missingClubCity, setMissingClubCity] = useState('');
    const [otherCategory, setOtherCategory] = useState(''); // For the "Other" input field
    const [isSubmitting, setIsSubmitting] = useState(false);

    const categories = ['Scorecard', 'Initiation Fee', 'Annual Dues', 'Missing Club', 'Other'];

    const handleCategoryChange = (event) => {
        const { value, checked } = event.target;

        if (value === 'Other' && !checked) {
            setOtherCategory(''); // Clear "Other" input if unchecked
        }

        if (checked) {
            setSelectedCategories([...selectedCategories, value]);
        } else {
            setSelectedCategories(selectedCategories.filter((cat) => cat !== value));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);

        const data = {
            categories: selectedCategories.includes('Other')
                ? [...selectedCategories.filter((cat) => cat !== 'Other'), otherCategory]
                : selectedCategories,
            comment: comments,
            missing_club_name: missingClubName,
            missing_club_state: missingClubState,
            missing_club_city: missingClubCity,
        };

        try {
            const response = await axiosInstance.post('/submit_update_view/', data);
            console.log('Submission successful:', response.data);
            alert('Update submitted successfully!');
            setSelectedCategories([]);
            setComments('');
            setOtherCategory('');
            setMissingClubName('');
            setMissingClubState('');
            setMissingClubCity('');
            onClose();
        } catch (error) {
            console.error('Error submitting update:', error.response?.data || error.message);
            alert('Failed to submit the update. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contribution-update-form overlay">
            <div className="form-container-contribution-update">
                <h2>Submit Contribution Update</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Select Categories:</label>
                        <div className="checkbox-group">
                            {categories.map((category) => (
                                <label key={category} className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        value={category}
                                        checked={selectedCategories.includes(category)}
                                        onChange={handleCategoryChange}
                                    />
                                    {category}
                                </label>
                            ))}
                        </div>
                        {selectedCategories.includes('Other') && (
                            <div className="form-group2">
                                <input
                                    type="text"
                                    placeholder="Specify other category"
                                    value={otherCategory}
                                    onChange={(e) => setOtherCategory(e.target.value)}
                                    className="other-category-input"
                                />
                            </div>
                        )}
                    </div>

                    {selectedCategories.includes('Missing Club') && (
                        <div className="form-group">
                            <label>Missing Club Details:</label>
                            <input
                                type="text"
                                placeholder="Club Name"
                                value={missingClubName}
                                onChange={(e) => setMissingClubName(e.target.value)}
                                className="input-field"
                            />
                            <input
                                type="text"
                                placeholder="State"
                                value={missingClubState}
                                onChange={(e) => setMissingClubState(e.target.value)}
                                className="input-field"
                            />
                            <input
                                type="text"
                                placeholder="City"
                                value={missingClubCity}
                                onChange={(e) => setMissingClubCity(e.target.value)}
                                className="input-field"
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Comments:</label>
                        <textarea
                            placeholder="Describe the issue or update..."
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            className="comments-box"
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="submit-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={onClose}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContributionUpdate;
